import { breadcrumb } from './breadcrumb';

export const db = {
  breadcrumb,

  database: {
    status: {
      fresh: 'Creature',
      processing: 'Import',
      error: 'Kesalahan',
      ready: 'Benar',
      removed: 'Ganti',
      sorting: 'Sortir'
    },

    field: {
      recipients: 'Penerima',
      group: 'Kelompok'
    },

    table: {
      action: {
        move: 'Pindahkan',
        add_contact: 'Tambah kontak'
      }
    },

    button: {
      create: 'Buat database'
    },

    form: {
      without_group: 'Tanpa kelompok'
    },

    modal: {
      remove: {
        content: 'Anda yakin akan menghapus database {nama}?'
      }
    }
  },

  group: {
    field: {
      databases_count: 'Database'
    },

    modal: {
      remove: {
        content: 'Anda yakin akan menghapus kelompok {nama}?'
      }
    },

    button: {
      create: 'Buat kelompok'
    }
  },

  recipient: {
    required_format: 'Harus sesuai nomor format international.',
    birthdate_format: 'DD.MM',
    not_allow_select: 'Tidak dapat memilih basis data, tidak ada penerima',

    field: {
      number: 'Telephone',
      email: 'Alamat e-mail',
      first_name: 'Name depan',
      last_name: 'Nama Akhir',
      age: 'Usia',
      sex: 'Kelamin',
      country: 'Negara',
      city: 'Kota',
      birthdate: 'Tanggal lahir',
      custom1: 'Kolom #1',
      custom2: 'Kolom #2',
      custom3: 'Kolom #3',
      custom4: 'Kolom #4',
      custom5: 'Kolom #5'
    },

    tags: {
      number: 'Telephone',
      email: 'Alamat e-mail',
      first_name: 'Name depan',
      last_name: 'Nama Akhir',
      age: 'Usia',
      country: 'Negara',
      city: 'Kota',
      birthdate: 'Tanggal lahir',
      custom1: 'Kolom #1',
      custom2: 'Kolom #2',
      custom3: 'Kolom #3',
      custom4: 'Kolom #4',
      custom5: 'Kolom #5'
    },

    button: {
      create: 'Buat kontak',
      import: 'Impor',
      export: 'Ekspor',
      sort: 'Sortir'
    },

    modal: {
      remove: {
        content: 'Anda yakin akan menghapus penerima beserta nomornya {number}?'
      },

      import: {
        title: 'Import Database',
        content: 'Import file (csv, xls).',
        required_format: 'Harus sesuai nomor format international.',
        field_title: {
          number: 'Telephone',
          email: 'Alamat e-mail',
          first_name: 'Name depan',
          last_name: 'Nama Akhir',
          age: 'Usia',
          sex: 'Sex',
          male: 'Pria',
          female: 'Perempuan',
          Male: 'Pria',
          Female: 'Perempuan',
          country: 'Negara',
          city: 'Kota',
          birthdate: 'Tanggal lahir',
          custom1: 'Kolom #1',
          custom2: 'Kolom #2',
          custom3: 'Kolom #3',
          custom4: 'Kolom #4',
          custom5: 'Kolom #5'
        }
      },

      export: {
        title: 'Export Database',
        content: 'Pilih kolom yang akan di-export',
        button: {
          download: 'Unduh'
        },
        success: 'Export database dimulai. Anda akan menerima notifikasi dan link unduhan.'
      }
    },
    successful_sort: 'Sortir sukses '
  },

  import: {
    tooltip: {
      header: 'Setidaknya satu kolom harus berupa nomor telepon'
    },
    create: {
      description:
        'Nomor telepon adalah bidang wajib untuk pengiriman. Setiap bidang harus memiliki nama yang unik. Anda dapat menetapkan nama bidang ke data aktual.',
      count: 'Database termasuk kontak: {count}',
      button: {
        upload_data: 'Unggah data',
        ignore_header: 'Abaikan header'
      }
    }
  },

  tooltips: {
    export_your_db: 'Ekspor database Anda ke file csv'
  }
};
